































































import { Vue, Component, PropSync } from 'vue-property-decorator'
import moment from 'moment'

import { CallDetailsInformation } from '@/types'
import config from '@/config'
import { getCallReportingHomeURL } from '@/utils'

@Component({
  filters: {
    formatTime (time: string) {
      return time ? moment(time, ['HH:mm']).format('h:mm A') : null
    }
  }
})
export default class Confirmation extends Vue {
  @PropSync('formStep')
  private step!: 'Details' | 'Review' | 'Confirmation'

  @PropSync('callDetails')
  private data!: CallDetailsInformation

  private onSubmit () {
    // TODO: send request
    this.step = 'Confirmation'
  }

  private get isMagenta () {
    return config.isMagenta
  }

  private get getCallReportingHomeURL () {
    return getCallReportingHomeURL()
  }

  private get formattedPhoneNumber () {
    const phoneNumber = this.data.number

    function formatPhoneNumber (phoneNumber: string) {
      const npa = phoneNumber.slice(0, 3)
      const nxx = phoneNumber.slice(3, 6)
      const local = phoneNumber.slice(6, 10)

      return `(${npa}) ${nxx}-${local}`
    }

    if (phoneNumber.length === 10) {
      return formatPhoneNumber(phoneNumber)
    } else if (phoneNumber.length === 11 && phoneNumber.startsWith('1')) {
      return '+1 ' + formatPhoneNumber(phoneNumber.slice(-10))
    } else {
      return phoneNumber
    }
  }
}
